<template>
  <PageContainer title="Cobranças Extras" data-testid="cobrancas-extras-page">
    <Box space="medium" class="cobrancas-container" data-testid="cobrancas-extras-container">
      <div class="loading" v-if="loading" data-testid="loading-area">
        <LoadingSpinner data-testid="loading-spinner" />
      </div>

      <div class="table-container" v-else-if="cobrancas.length > 0" data-testid="table-container">
        <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
          @page-changed="fetchCobrancas" data-testid="pagination" />

        <Table :headers="['Valor', 'Status', 'Vencimento', 'Emissão', 'Ações']" data-testid="cobrancas-table">
          <tr v-for="(cobranca, index) in cobrancas" :key="cobranca.id" :data-testid="`cobranca-row-${index}`">
            <td data-testid="cell-valor">{{ utils.formatarValor(cobranca.amount / 100) }}</td>
            <td v-if="cobranca.boleto.status === 'pending'" style="color: #FABF10;" data-testid="cell-status-pending">
              Pendente</td>
            <td v-else-if="cobranca.boleto.status === 'paid'" style="color: #16A34A;" data-testid="cell-status-paid">
              Pago</td>
            <td v-else-if="cobranca.boleto.status === 'cancelled'" style="color: #CA2222;"
              data-testid="cell-status-cancelled">Cancelado</td>
            <td v-else-if="cobranca.boleto.status === 'overdue'" style="color: #CA2222;"
              data-testid="cell-status-overdue">Vencido</td>
            <td data-testid="cell-vencimento">{{ utils.formatOnlyDate(cobranca.boleto.due_date.split(" ")[0]) }}</td>
            <td data-testid="cell-emissao">{{ utils.formatOnlyDate(cobranca.boleto.open_date.split(" ")[0]) }}</td>
            <td data-testid="cell-actions">
              <div class="actions" data-testid="actions-container">
                <div>
                  <IconButton @handle:click="() => openDetails(cobranca)" color="secondary" title="Detalhes"
                    :disabled="loadingActions" data-testid="btn-detalhes">
                    <InformationOutline :size="19" />
                  </IconButton>
                </div>

                <div v-if="['pending'].includes(cobranca.boleto.status)">
                  <IconButton @handle:click="() => ticketPDFDownlaod(cobranca.id)" color="success" title="Baixar boleto"
                    :disabled="loadingActions" data-testid="btn-baixar-boleto">
                    <FileOutline :size="19" />
                  </IconButton>
                </div>

                <!-- <div v-if="['pending'].includes(cobranca.boleto.status)">
                  <IconButton @handle:click="() => updateBolecode(cobranca.id)" color="primary"
                    title="Atualizar cobrança" :disabled="loadingActions" data-testid="btn-atualizar-cobranca">
                    <Reload :size="19" />
                  </IconButton>
                </div> -->
              </div>
            </td>
          </tr>
        </Table>
      </div>

      <div v-if="cobrancas.length === 0" data-testid="empty-state">
        <p class="empty" data-testid="empty-message">Não existe cobrança extra para sua autoescola.</p>
      </div>
    </Box>

    <CobrancaInfos ref="cobrancaInfos" data-testid="modal-cobranca-infos" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Paginate from 'core/Paginate'
import Table from 'core/Table'
import IconButton from 'core/IconButton'

import FileOutline from 'icons/FileOutline'
import InformationOutline from 'icons/InformationOutline'
import Cancel from 'icons/Cancel'
import Reload from 'icons/Reload'

import utils from '../../services/utils'
import _export from '../../services/export'
import CobrancaInfos from './CobrancaInfos'

export default {
  name: "BuscarCobrancas",
  components: {
    PageContainer,
    Box,
    Button,
    LoadingSpinner,
    Paginate,
    Table,
    IconButton,

    FileOutline,
    InformationOutline,
    Cancel,
    Reload,

    CobrancaInfos,
  },
  data() {
    return {
      utils: utils,
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      cobrancas: [],
      loading: false,
      loadingActions: false,
    }
  },
  async created() {
    await this.fetchCobrancas()
  },
  methods: {
    async fetchCobrancas(page = 1) {
      this.loading = true

      const params = {
        page,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/cobrancas`, {
        params,
      })
        .then(response => {
          const result = response.body.dados

          if (result.data.length === 0) {
            this.$toasted.show('Nenhum resultado encontrado.', {
              icon: 'fa-times',
              position: 'top-right',
            })

            this.cobrancas = []

            this.paginationData = {
              currentPage: 1,
              lastPage: 1,
              total: 0,
            }

            return
          }

          this.cobrancas = result.data

          this.paginationData = {
            currentPage: result.current_page,
            lastPage: result.last_page,
            total: result.total,
          }
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar autoescolas.', {
            icon: 'fa-times',
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async ticketPDFDownlaod(id) {
      this.loadingActions = true

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/cobrancas/${id}/download`, {
        responseType: 'blob',
      })
        .then(response => response.blob())
        .then(response => {
          _export.downloadPDFBlob(response, 'boleto')
        })
        .catch(err => {
          this.$toasted.show('Erro ao tentar baixar o boleto.', {
            icon: 'fa-times',
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loadingActions = false
        })
    },
    openDetails(cobranca) {
      this.$refs.cobrancaInfos.open(cobranca)
    },
    async updateBolecode(id) {
      this.loadingActions = true

      await this.$http.put(`${process.env.VUE_APP_URL_API_V2}/cobrancas/${id}/update-bolecode`)
        .then(response => {
          this.fetchCobrancas(this.paginationData.currentPage)

          this.$toasted.show(response.body.mensagem, {
            icon: 'fa-check',
            position: 'top-right',
          })
        })
        .catch(err => {
          this.$toasted.show('Erro ao tentar atualizar o boleto.', {
            icon: 'fa-times',
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loadingActions = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cobrancas-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }

    .table-container {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .infos {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 1.5rem;
      }

      .table-header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;

        .table-legend {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0.625rem;

          >div {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
        }
      }

      .actions {
        max-width: 8rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        row-gap: 0.5rem;

        div {
          padding: 0 0.5rem;
          display: flex;
          justify-content: center;

          &:not(:last-child) {
            border-right: 1px solid #ECECEC;
          }
        }
      }
    }
  }
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 600;
  color: #808080;
  text-align: center;
}
</style>